(function () {
  const ATTR_CONFIG = {
    ref: 'ref',
    discount_code: 'discount_code'
  };
  const EXPIRY_DAYS = 30;

  function setWithExpiry(key, value) {
    const item = {
      value: value,
      expiry: Date.now() + EXPIRY_DAYS * 24 * 60 * 60 * 1000
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);
      if (Date.now() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      return item.value;
    } catch (e) {
      localStorage.removeItem(key);
      return null;
    }
  }

  // Step 1: capture params from URL and store them for 30 days
  function captureAttributionParams() {
    const urlParams = new URLSearchParams(window.location.search);

    Object.entries(ATTR_CONFIG).forEach(([storageKey, urlParam]) => {
      const value = urlParams.get(urlParam);
      if (value) {
        setWithExpiry(storageKey, value);
      }
    });
  }

  // Step 2: push whatever is currently stored into the cart as attributes
  function syncCartAttributes() {
    const attributes = {};
    let hasAttribute = false;

    Object.keys(ATTR_CONFIG).forEach((storageKey) => {
      const value = getWithExpiry(storageKey);
      if (value) {
        attributes[storageKey] = value;
        hasAttribute = true;
      }
    });

    if (!hasAttribute) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then((res) => res.json())
      .then((cart) => {
        console.log('Cart attributes synced:', cart.attributes);
      })
      .catch((err) => console.error('Cart attribute sync failed:', err));
  }

  captureAttributionParams();
  syncCartAttributes();
})();